


















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/tenugui/PopupTemplate.vue'
import QuizTenugui from '@/views/organisms/QuizTenugui.vue'

export default
  components: {
    PopupTemplate
    QuizTenugui
  }

  data: () ->
    baseColor: '#4D2095'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        'スポーツてぬぐいが一番よく使われるシーンは'
        '次のうちどれでしょうか？'
      ]
      quiz: [
        'アウトドア・スポーツシーン'
        'ご自宅・ヘアバンダナとして'
        'マスクとして'
      ]
      success_message: [
        '「もっとおしゃれで、もっと機能的に使えるアクティビティ用タオルがあったら、'
        'アウトドアやスポーツも楽しいのに…。」という思いから開発した'
        'スポーツてぬぐいは、アウトドアやスポーツシーンで最もよく使われるんだ！'
      ]
      answer: 1

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p2-16'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
